const PENDING_PAYMENT_METHODS = new Set(['PENDIENTEPAGO', 'PENDIENTEDEPAGO'])

const normalizePaymentMethod = value =>
  String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')

const isPendingPaymentMethod = value =>
  PENDING_PAYMENT_METHODS.has(normalizePaymentMethod(value))

export const hasPendingOrEmptyPaymentMethod = paymentMethod => {
  if (
    paymentMethod == null ||
    paymentMethod === '' ||
    (Array.isArray(paymentMethod) && paymentMethod.length === 0)
  ) {
    return true
  }

  const paymentMethods = Array.isArray(paymentMethod)
    ? paymentMethod
    : [paymentMethod]

  return paymentMethods.some(payment => {
    if (typeof payment === 'string') {
      return isPendingPaymentMethod(payment)
    }

    const paymentMethodCandidates = [
      payment?.PaymentName,
      payment?.PaymentTypeId,
      payment?.PaymentMethodId,
      payment?.PaymentMethodDetails?.PaymentTypeId,
      payment?.PaymentMethodDetails?.PaymentMethodId,
    ]

    return (
      paymentMethodCandidates.some(isPendingPaymentMethod) ||
      Object.keys(payment || {}).some(isPendingPaymentMethod)
    )
  })
}
